// 与 cupshe-axios 的 400001 登录失效处理保持一致。
export function handleLoginExpired() {
  localStorage.setItem('token', '')
  window.parent.postMessage('400001', '*')
  window.location.href = '/login'
}
